import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/imageUtils';

const ImageCropperModal = ({ imageSrc, onCropComplete, onCancel }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    const handleCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleSave = async () => {
        try {
            setIsSaving(true);
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

            // Create a File object from the blob
            const croppedFile = new File([croppedImageBlob], "profile.jpg", {
                type: 'image/jpeg',
                lastModified: Date.now(),
            });

            onCropComplete(croppedFile);
        } catch (e) {
            console.error("Crop error", e);
            alert("Failed to crop image.");
            setIsSaving(false);
        }
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.95)', zIndex: 9999,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(4px)'
        }}>
            <div style={{ width: '100%', maxWidth: '600px', padding: '0 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <h3 style={{ color: '#fff', margin: 0, fontSize: '1.25rem', fontWeight: 600 }}>Adjust your picture</h3>
            </div>

            <div style={{
                position: 'relative', width: '90%', maxWidth: '500px', height: '50vh',
                backgroundColor: '#1e293b', borderRadius: '16px', overflow: 'hidden',
                boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                border: '1px solid rgba(255,255,255,0.1)'
            }}>
                <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    cropShape="round"
                    showGrid={false}
                    onCropChange={setCrop}
                    onCropComplete={handleCropComplete}
                    onZoomChange={setZoom}
                />
            </div>

            <div style={{
                marginTop: '2rem', width: '90%', maxWidth: '500px',
                display: 'flex', flexDirection: 'column', gap: '1.5rem', alignItems: 'center'
            }}>
                {/* Zoom control */}
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Zoom</span>
                    <input
                        type="range"
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                        aria-labelledby="Zoom"
                        onChange={(e) => setZoom(e.target.value)}
                        style={{ flex: 1, cursor: 'pointer', accentColor: '#3b82f6' }}
                    />
                </div>

                <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
                    <button
                        onClick={onCancel}
                        disabled={isSaving}
                        style={{
                            flex: 1,
                            padding: '0.8rem', borderRadius: '12px', border: '1px solid #475569',
                            background: 'rgba(255,255,255,0.05)', color: '#f8fafc', cursor: isSaving ? 'not-allowed' : 'pointer',
                            fontSize: '0.95rem', fontWeight: 600, transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.1)'}
                        onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.05)'}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={isSaving}
                        style={{
                            flex: 1,
                            padding: '0.8rem', borderRadius: '12px', border: 'none',
                            background: isSaving ? '#64748b' : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: '#fff', cursor: isSaving ? 'not-allowed' : 'pointer',
                            fontSize: '0.95rem', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                            boxShadow: isSaving ? 'none' : '0 8px 16px rgba(37, 99, 235, 0.2)', transition: 'all 0.2s'
                        }}
                    >
                        {isSaving ? "Processing..." : "Crop & Upload"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropperModal;
